import { getEnv } from "@/shared/utils/env-utils";
import { UserRole } from "../types";

/**
 * Azure AD Group ID to Role mapping
 */
export const KnownGroupIds: Record<string, UserRole> = {
    [getEnv("VITE_AZURE_GROUP_ADMIN")]: UserRole.ADMIN,
    [getEnv("VITE_AZURE_GROUP_REGIEVOERDER")]: UserRole.REGIEVOERDER,
    [getEnv("VITE_AZURE_GROUP_KLANTENSERVICE")]: UserRole.KLANTENSERVICE,
    [getEnv("VITE_AZURE_GROUP_RCB_TRANSVISION")]: UserRole.TRANSVISION,
    [getEnv("VITE_AZURE_GROUP_RCB_DEWIT")]: UserRole.DEWIT,
    [getEnv("VITE_AZURE_GROUP_SUPPORTCONSULTANT")]: UserRole.SUPPORTCONSULTANT,
    [getEnv("VITE_AZURE_GROUP_VRIJWILLIGER")]: UserRole.VRIJWILLIGER,
    [getEnv("VITE_AZURE_GROUP_ALLEEN_LEZEN")]: UserRole.ALLEENLEZEN,
};

/**
 * Map AD groups to application roles using group IDs
 */
export const mapGroupsToRoles = (groupIds: string[]): UserRole[] => {
    return [...new Set(groupIds.map((id) => KnownGroupIds[id]).filter(Boolean))];
};

/**
 * Check if user has a specific role based on group membership
 */
export const hasGroupRole = (role: UserRole, groupIds: string[]): boolean => {
    return mapGroupsToRoles(groupIds).includes(role);
};
